import { useEffect, useState, useCallback } from "react";
import { getPrescriptionsByHistorytId } from "../../api/prescriptionService";
import { getPrescriptionsByHistoryEntrytId } from "../../api/prescriptionService";
import { getPrescriptionsByPetId } from "../../api/prescriptionService";
export const usePrescriptions = (historyId, entryId, petId, mode, trigger, initialPage = 1, initialLimit = 10) => {
    const [prescriptions, setPrescriptions] = useState({
        data: [],
        pagination: { page: initialPage, limit: initialLimit, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = initialPage, limit = initialLimit, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response;
              if (mode === 'pet')
              {
                
                response = await getPrescriptionsByPetId(petId, page, limit);
              }
              else {
                if (entryId)
                {
                  response = await getPrescriptionsByHistoryEntrytId(entryId, page, limit);
                } else {
                  response = await getPrescriptionsByHistorytId(historyId, page, limit);
                }
              }
              setPrescriptions(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch prescriptions:", err);
            } finally {
                setLoading(false);
            }
        },
        [initialPage, initialLimit, searchTerm]
    );

    useEffect(() => {
        fetchData(initialPage, initialLimit, false, searchTerm);
    }, [trigger, fetchData, initialPage, initialLimit, searchTerm]);

    const loadMore = async () => {
        const nextPage = prescriptions.pagination.page + 1;
        if (nextPage <= prescriptions.pagination.totalPages) {
        await fetchData(nextPage, prescriptions.pagination.limit, true, searchTerm);
        }
    };

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, prescriptions.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(initialPage, initialLimit, false, "");
    };

    return { prescriptions, loading, loadMore, searchFunction, resetParent };
};